/**
 * Asynchronously loads the component for FeaturePage
 */
import { loadable } from '@elliemae/pui-app-sdk';

const LoadableInvestorConfiguration = loadable(
  () =>
    import(
      /* webpackChunkName: "investor-configuration" */ /* webpackPrefetch: true */ './index'
    ),
);

export default LoadableInvestorConfiguration;
